module.exports = __webpack_public_path__ + "static/media/Apercu-Regular.36f209f7.otf";